import { useState } from "react";
import { NavLink } from "react-router-dom";
import { jobseekerStmCount } from "../Utilities/Helper";

export default function SeekerMenu({ show, setToggleFalse }) {
  const [linkDisabled, setlinkDisabled] = useState(true);

  const handleClick = (e) => {
    if (linkDisabled) e.preventDefault();
  };

  return (
    <ul>
      <li onClick={setToggleFalse}>
        <NavLink
          activeClassName="is-active"
          to={`${process.env.PUBLIC_URL}/seeker/dashboard`}
        >
          <span className="icon icon-wysiwyg"></span>
          Dashboard
        </NavLink>
      </li>
      <li onClick={setToggleFalse}>
        {show ?
          <NavLink
            activeClassName="is-active"
            to={`${process.env.PUBLIC_URL}/network`}
          >
            <span className="icon icon-people_outline"></span> Network
          </NavLink>
          :
          <NavLink
            activeClassName="is-active"
            to={`${process.env.PUBLIC_URL}/network`}
            onClick={handleClick}
            style={{ color: "#c7c7c7" }}
          >
            <span className="icon icon-people_outline disabled"></span> Network
          </NavLink>
        }
      </li>
      <li onClick={setToggleFalse}>
        <NavLink
          activeClassName="is-active"
          to={`${process.env.PUBLIC_URL}/jobseeker/jobs`}
        >
          <span className="icon icon-manage_search"></span> Jobs
        </NavLink>
      </li>
      <li onClick={setToggleFalse}>
        <NavLink
          activeClassName="is-active"
          to={`${process.env.PUBLIC_URL}/jobseeker/myresumes`}
        >
          <span className="icon icon-file_present"></span> My Resume
        </NavLink>
      </li>
      <li onClick={setToggleFalse}>
        <NavLink
          activeClassName="is-active"
          to={`${process.env.PUBLIC_URL}/jobseeker/messages`}
        >
          <span className="icon icon-chat_bubble_outline"></span> Messages
        </NavLink>
      </li>
      <li onClick={setToggleFalse}>
        {show ?
          <NavLink
            activeClassName="is-active"
            to={`${process.env.PUBLIC_URL}/SeekersConnections`}
          >
            <span className="icon icon-group-add"></span> Connections
          </NavLink>
          :
          <NavLink
            activeClassName="is-active"
            to={`${process.env.PUBLIC_URL}/SeekersConnections`}
            onClick={handleClick}
            style={{ color: "#c7c7c7" }}
          >
            <span className="icon icon-group-add"></span> Connections
          </NavLink>}
      </li>
      <li onClick={setToggleFalse}>
        <NavLink
          activeClassName="is-active"
          to={`${process.env.PUBLIC_URL}/jobseeker/sponsorship`}
        >
          <span className="icon icon-people_outline"></span> Sponsorships
        </NavLink>
      </li>

      {/* #CTRL-2107 REMOVE TIPS TO GET STARTED FROM SEEKER MENU 
      <li
        onClick={setToggleFalse}
        style={{
          margin: '40px 15px 10px 15px',
          padding: '8px 0',
          borderLeft: '5px solid #c3e6cb',
          borderRight: '5px solid #c3e6cb',
          borderRadius: '4px',
          background: 'rgb(212 237 218 / 8%)',
          boxShadow: '0 1px 2px rgba(0,0,0,0.08)'
        }}
      >
        <NavLink
          to={`${process.env.PUBLIC_URL}/jobseeker/tips`}
          style={{
            display: 'flex',
            alignItems: 'center',
            whiteSpace: 'nowrap',
          }}
        >
          <span>Tips To Get Started</span>
        </NavLink>
      </li> */}

    </ul>
  );
}

// export default SeekerMenu;
